import type { RfqPackage } from '../types';
import { packageCoversHubRelease } from './rfqPackageReleases';

/** Package doc ids to sync when the supplier-facing staged release name changes. */
export function rfqPackageIdsForHubRelease(
  packages: RfqPackage[],
  rfqProjectId: string,
  hubFileReleaseId: string,
): string[] {
  const projectId = rfqProjectId.trim();
  const hubId = hubFileReleaseId.trim();
  if (!projectId || !hubId) return [];
  return packages
    .filter(
      (p) =>
        p.id
        && p.rfqProjectId === projectId
        && packageCoversHubRelease(p, hubId),
    )
    .map((p) => p.id as string);
}

export function normalizeRfqReleaseDisplayLabel(raw: string, fallbackFileName: string): string {
  const trimmed = raw.trim();
  if (trimmed) return trimmed;
  return fallbackFileName.trim() || 'Release';
}
